<template>
  <div class="menu-edit">
    <base-headline title="基本信息" class="headline no-top" />
    <el-form class="zwx-form edit-form"  key="mainForm" ref="mainForm" :model="mainForm"
             :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <div style="max-width: 344px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="84px" label="菜单编号：" prop="menuNotice">
          <el-input class="zwx-input" style="width: 320px !important;"  v-model="mainForm.menuNotice" maxlength="30" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="菜单标题：" prop="menuTitle">
          <el-input class="zwx-input" style="width: 320px !important;"  v-model="mainForm.menuTitle" maxlength="15" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="菜单图标：" prop="menuIcon">
          <el-input class="zwx-input" style="width: 320px !important;" v-model="mainForm.menuIcon" maxlength="60" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="菜单子图标：">
          <el-input class="zwx-input" style="width: 320px !important;"  v-model="mainForm.menuChildIcon" maxlength="60" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="菜单类别：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.menuType" @change="menuTypeChange">
            <el-radio class="zwx-radio" :label="0" :key="0">目录</el-radio>
            <el-radio class="zwx-radio" :label="1" :key="1">内部菜单</el-radio>
            <el-radio class="zwx-radio" :label="2" :key="2">外部菜单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="84px" label="菜单URL：" prop="menuUrl" v-if="mainForm.menuType !== 0">
          <el-input class="zwx-input" v-model="mainForm.menuUrl" maxlength="150" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <!-- 提交部分 -->
    <fixed-footer>
      <el-button class="zwx-button zwx-button-32" type="primary"
                 @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交
      </el-button>
    </fixed-footer>
  </div>
</template>

<script>
export default {
  name: "MenuEdit",
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      mainForm: {
        menuNotice: "",
        menuTitle: "",
        menuIcon: "",
        menuChildIcon: "",
        menuUrl: "",
        menuType: 0,
        ifEnable: true
      },
      rules: {
        menuNotice: [{ required: true, message: "请输入菜单编号", trigger: ["change", "blur"] }],
        menuTitle: [{ required: true, message: "请输入菜单标题", trigger: ["change", "blur"] }],
        menuIcon: [{ required: true, message: "请输入菜单图标", trigger: ["change", "blur"] }],
        menuUrl: [{
          required: true,
          pattern: /(^(http|https):\/\/\S)|^\/\S/,
          message: "请输入以http://或https://或/开头的菜单URL",
          trigger: ["change", "blur"]
        }]
      }
    };
  },
  created() {
  },
  mounted() {
    this.detail();
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    }
  },
  methods: {
    detail() {
      if (this.rid === undefined) return;
      this.$emit("loading", true);
      let data = {
        rid: this.rid
      };
      this.$system.get(this.api + "/systematic/getMenu-1", data, true, true, this.detailSuccess, this.detailError);
    },
    detailSuccess(data) {
      if (data.type === "00") {
        this.mainForm.menuNotice = data.menu.menuNotice;
        this.mainForm.menuTitle = data.menu.menuTitle;
        this.mainForm.menuIcon = data.menu.menuIcon;
        this.mainForm.menuChildIcon = data.menu.menuChildIcon;
        this.mainForm.menuUrl = data.menu.menuUrl;
        this.mainForm.menuType = data.menu.menuType;
        this.mainForm.ifEnable = data.menu.ifEnable;
        this.$emit("loading", false);
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
        this.back();
      }
    },
    detailError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
      this.back();
    },
    menuTypeChange(label) {
      if (label === 0) this.mainForm.menuUrl = "";
    },
    commit() {
      this.$emit("loading", true);
      let data = {
        rid: this.rid,
        menuNotice: this.mainForm.menuNotice,
        menuTitle: this.mainForm.menuTitle,
        menuIcon: this.mainForm.menuIcon,
        menuChildIcon: this.mainForm.menuChildIcon,
        menuUrl: this.mainForm.menuUrl,
        menuType: this.mainForm.menuType,
        ifEnable: this.mainForm.ifEnable
      };
      this.$system.postJson(this.api + "/systematic/addOrModifyMenu-1", data, true, true, this.commitSuccess, this.commitError);
    },
    commitSuccess(data) {
      if (data.type === "00") {
        this.$system.notify("成功", data.mess, "success");
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } });
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
      }
    },
    commitError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name });
    }
  }
};
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
